import { onAuthStateChanged, signOut } from "firebase/auth";
import { useState, useEffect } from "react";
import {
  auth,
  db,
  getCentros,
  getHorarios,
  getRegistro,
  getSolicitudes,
  getTrabajadores,
  getUser,
} from "../firebase/firebase";
import { useNavigate } from "react-router-dom";
import ListaTrabajadores from "../components/controlhorarioadmin/ListaTrabajadores";
import Header from "../components/controlhorarioadmin/Header";
import Footer from "../components/controlhorarioadmin/Footer";
import HeaderLoading from "../components/controlhorarioadmin/HeaderLoading";
import ListaTrabajadoresLoading from "../components/controlhorarioadmin/ListaTrabajadoresLoading";
import { colorProject } from "./../js/project"
import { collection, onSnapshot, query } from "firebase/firestore";

// ruta predeterminada administradores

export function ControlHorarioAdmin() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [horariosPrestablecidos, setHorariosPrestablecidos] = useState(null)
  const [centros, setCentros] = useState(null)
  const [trabajadores, setTrabajadores] = useState(null)
  const [solicitudesYRegistros, setSolicitudesYRegistros] = useState(null)

  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userDB = await getUser(user.uid);
        setUser(userDB);

        if (userDB.estado === false) {
          logout()
        } 
        else if (userDB.primerAcceso === true) {
          navigate("/changePassword")
        } 
        else if (userDB.admin === false) {
          navigate("/controlHorario")
        }
        
        const horariosPrestablecidosAux = await getHorarios()
        horariosPrestablecidosAux.sort((a, b) => parseInt(a.id) - parseInt(b.id))
        setHorariosPrestablecidos(horariosPrestablecidosAux)
        setCentros(await getCentros())
        setTrabajadores(await getTrabajadores())

        const unsubscribe = subscribeToSolicitudes(setSolicitudesYRegistros)
        return () => unsubscribe();

      } else {
        navigate("/login");
      }
    });
  }, [navigate]);

  function subscribeToSolicitudes(setStateCallback) {

    const q = query(collection(db, "solicitudes_cambio"));

    const unsubscribe = onSnapshot(
      q,
      async (querySnapshot) => {
        const solicitudes = querySnapshot.docs.map(doc => doc.data());

        const pares = await Promise.all(
          solicitudes.map(async (solicitud) => {
            const registro = await getRegistro(
              solicitud.datosTrabajador,
              solicitud.datosTrabajador.fecha
            );
            return { solicitud, registro: registro ?? "" };
          })
        );

        pares.sort((a, b) => {
          const fechaA = new Date(a.solicitud.fecha);
          const fechaB = new Date(b.solicitud.fecha);
          return fechaA - fechaB;
        });

        setStateCallback(pares);

      },
      (error) => {
        // console.error("Error al escuchar cambios en solicitudes:", error);
      }
    );

    return unsubscribe;
  }

  // async function getRegistrosBySolicitudes() {
  //   const solicitudes = await getSolicitudes();

  //   const pares = await Promise.all(
  //     solicitudes.map(async solicitud => {
  //       const registro = await getRegistro(solicitud.datosTrabajador, solicitud.datosTrabajador.fecha);
  //       return { solicitud, registro: registro ?? "" }; // si es undefined, lo cambia a ""
  //     })
  //   );

  //   pares.sort((a, b) => {
  //     const fechaA = new Date(a.solicitud.fecha);
  //     const fechaB = new Date(b.solicitud.fecha);
  //     return fechaA - fechaB;
  //   });

  //   setSolicitudesYRegistros(pares);
  // }

  // async function getRegistrosBySolicitudes() {
  //   const solicitudes = await getSolicitudes()
  //   const registros = []

  //   solicitudes.forEach(solicitud => {
  //     registros.push(await getRegistro(solicitud.datosTrabajador, solicitud.datosTrabajador.fecha))
  //   })
  // }

  function logout() {
    signOut(auth)
      .then(() => {
        // console.log("OUT");
      })
      .catch((error) => {
        // console.error(error);
        // console.log("error logout");
      });

    //console.log("OUT");
    //auth().logout();
    //window.location.href = "login.html";
  }

  if (user !== null && user.admin === true && user.estado === true && horariosPrestablecidos !== null && trabajadores !== null && centros !== null && solicitudesYRegistros !== null) {
    return (
      <>            
        <div style={{backgroundColor: colorProject}}>
          <div className="container1140px bgwhite">
            <Header user={user} horariosPrestablecidos={horariosPrestablecidos} solicitudesAux={solicitudesYRegistros} />
            <main className="padding-20">
              <ListaTrabajadores user={user} trabajadoresAux={trabajadores} centros={centros} horariosPrestablecidos={horariosPrestablecidos} />
            </main>
            <Footer/>
          </div>
        </div>
      </>
    );
  } 
  else {
    return (
      <>            
        <div style={{backgroundColor: colorProject}}>
          <div className="container1140px bgwhite">
            <HeaderLoading />
            <main className="padding-20">
              <ListaTrabajadoresLoading />
            </main>
            <Footer/>
          </div>
        </div>
      </>
    );  
  }
}
